import {Component, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {User} from '../model/user.model';
import {Router} from '@angular/router';
import {StateService} from '../state.service';

type SortKey = 'lastname' | 'firstname' | 'sponsoringSince';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
    standalone: false
})
export class UserComponent implements OnDestroy {

  private subscription: Subscription;
  private allUsers: User[] = [];

  filteredUsers: User[] = [];
  searchTerm = '';
  sortKey: SortKey = 'lastname';

  sortOptions: {label: string, value: SortKey}[] = [
    {label: 'Nachname', value: 'lastname'},
    {label: 'Vorname', value: 'firstname'},
    {label: 'Pate seit', value: 'sponsoringSince'},
  ];

  constructor(private router: Router, private stateService: StateService) {
    this.subscription = this.stateService.getUsers().subscribe(users => {
      this.allUsers = users ?? [];
      this.applyFilters();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSearchChange(value: string) {
    this.searchTerm = value;
    this.applyFilters();
  }

  onSortChange(value: SortKey) {
    this.sortKey = value;
    this.applyFilters();
  }

  trackByUserId(_index: number, user: User) {
    return user.id;
  }

  editUser(user: User) {
    this.stateService.user = user;
    this.router.navigate(['editUser']);
  }

  deleteUser(_user: User) {
    alert('Pate kann nicht gelöscht werden.');
  }

  goToTree(treeReference: string) {
    const ref: string[] = treeReference.split(':');
    this.router.navigate(['field/' + ref[0] + '/line/' + ref[1] + '/tree/' + ref[2]]);
  }

  goToUserDetails(userId: string) {
    this.router.navigate(['home/userId/' + userId]);
  }

  getTreeReferenceSince(user: User, reference: string): string | undefined {
    return user.treeReferenceDates?.[reference] ?? user.sponsoringSince;
  }

  private applyFilters() {
    const term = this.searchTerm.trim().toLowerCase();
    let result = [...this.allUsers];

    if (term) {
      result = result.filter(user => {
        const haystack = [
          user.firstName ?? '',
          user.lastname ?? '',
          user.email ?? ''
        ].join(' ').toLowerCase();
        return haystack.includes(term);
      });
    }

    result.sort((a, b) => {
      switch (this.sortKey) {
        case 'firstname':
          return this.compareStrings(a.firstName, b.firstName);
        case 'sponsoringSince':
          return this.compareDates(a.sponsoringSince, b.sponsoringSince);
        case 'lastname':
        default:
          return this.compareStrings(a.lastname, b.lastname);
      }
    });

    this.filteredUsers = result;
  }

  private compareStrings(a?: string, b?: string) {
    const first = (a || '').toLocaleLowerCase();
    const second = (b || '').toLocaleLowerCase();
    return first.localeCompare(second, undefined, {sensitivity: 'base'});
  }

  private compareDates(a?: string, b?: string) {
    const first = a ? new Date(a).getTime() : 0;
    const second = b ? new Date(b).getTime() : 0;
    return first - second;
  }
}
